// src/components/Layout.js
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Headerr from './Headerr';
import '../styles/layout.css';

const Layout = ({ children, user, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-container">
      <Sidebar user={user} className={sidebarOpen ? 'open' : ''} />
      <Headerr
        user={user} 
        onLogout={onLogout}
        onMenuToggle={() => setSidebarOpen(!sidebarOpen)} 
      />
      <main className="main-content" onClick={() => setSidebarOpen(false)}>
        {children}
      </main>
    </div>
  );
};

export default Layout;